import { AxiosError } from "axios";
import { z } from "zod";

import { ReassignmentFailure } from "org/user/components/ReassignmentFailureAlert";
import { STATUS_CODE_ERROR_OPERATION_FAILED } from "utils/errorCodes";

const adminAccessFailureSchema = z.array(z.string());

export function describeAdminAccessFailure(
    error: unknown,
    message: string,
    labelOf: (id: string) => string
): ReassignmentFailure | null {
    if (
        !(error instanceof AxiosError) ||
        error.response?.status !== STATUS_CODE_ERROR_OPERATION_FAILED
    ) {
        return null;
    }
    const parsed = adminAccessFailureSchema.safeParse(error.response.data);
    if (!parsed.success) {
        return null;
    }
    return { message, items: parsed.data.map(labelOf) };
}
